// AUTO-GENERATED by scripts/genRoutes.mjs. Do not hand edit.
export const ORIGIN = "https://jeffupp.com";
export const PUBLIC_ROUTES = [
  {
    "path": "/",
    "title": "Jeff Upp - Real Estate Agent | Upland, CA",
    "description": "Jeff Upp of RE/MAX Champions serves Upland, the Inland Empire, and eastern Los Angeles County with experienced buyer and seller guidance since 1990.",
    "priority": 1,
    "changefreq": "weekly"
  },
  {
    "path": "/chat",
    "title": "Chat With Jeff Upp’s Real Estate Assistant",
    "description": "Ask about Southern California homes, neighborhoods, buying, selling, and your next real estate move.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/search",
    "title": "Search Southern California Homes | Jeff Upp",
    "description": "Search current CRMLS homes for sale across Upland, the Inland Empire, and surrounding Southern California communities.",
    "priority": 0.9,
    "changefreq": "daily"
  },
  {
    "path": "/blogs",
    "title": "Inland Empire Real Estate Journal | Jeff Upp",
    "description": "Local market insight, buyer and seller guidance, and Southern California real estate stories from Jeff Upp.",
    "priority": 0.8,
    "changefreq": "weekly"
  },
  {
    "path": "/reviews",
    "title": "Client Reviews | Jeff Upp, RE/MAX Champions",
    "description": "Read client stories about working with Jeff Upp to buy and sell homes across Southern California.",
    "priority": 0.8,
    "changefreq": "monthly"
  },
  {
    "path": "/about-us",
    "title": "About Jeff Upp | Upland & Inland Empire REALTOR®",
    "description": "Meet Jeff Upp of RE/MAX Champions, a Southern California REALTOR® serving buyers and sellers since 1990.",
    "priority": 0.9,
    "changefreq": "monthly"
  },
  {
    "path": "/contact-us",
    "title": "Contact Jeff Upp | Upland Real Estate",
    "description": "Contact Jeff Upp about buying, selling, investing, or relocating in Upland and the Inland Empire.",
    "priority": 0.8,
    "changefreq": "monthly"
  },
  {
    "path": "/terms-of-service",
    "title": "Terms of Service | Jeff Upp Real Estate",
    "description": "Terms governing use of the Jeff Upp real estate website and property-search services.",
    "priority": 0.2,
    "changefreq": "yearly"
  },
  {
    "path": "/privacy-policy",
    "title": "Privacy Policy | Jeff Upp Real Estate",
    "description": "Privacy policy for the Jeff Upp real estate website and communications tools.",
    "priority": 0.2,
    "changefreq": "yearly"
  },
  {
    "path": "/api-docs",
    "title": "Real Estate API Documentation | Jeff Upp",
    "description": "Public API documentation for property search and lead requests on the Jeff Upp real estate website.",
    "priority": 0.3,
    "changefreq": "monthly"
  },
  {
    "path": "/area/upland",
    "title": "Upland, CA Homes for Sale & Real Estate Guide | Jeff Upp",
    "description": "Explore Upland homes for sale, neighborhoods, housing styles, and local buyer guidance with Jeff Upp of RE/MAX Champions.",
    "priority": 0.8,
    "changefreq": "weekly"
  },
  {
    "path": "/area/claremont",
    "title": "Claremont, CA Homes for Sale & Real Estate Guide | Jeff Upp",
    "description": "Explore Claremont homes for sale, neighborhoods, housing styles, and local buyer guidance with Jeff Upp of RE/MAX Champions.",
    "priority": 0.8,
    "changefreq": "weekly"
  },
  {
    "path": "/area/rancho-cucamonga",
    "title": "Rancho Cucamonga, CA Homes for Sale & Real Estate Guide | Jeff Upp",
    "description": "Explore Rancho Cucamonga homes for sale, neighborhoods, housing styles, and local buyer guidance with Jeff Upp of RE/MAX Champions.",
    "priority": 0.8,
    "changefreq": "weekly"
  },
  {
    "path": "/area/ontario",
    "title": "Ontario, CA Homes for Sale & Real Estate Guide | Jeff Upp",
    "description": "Explore Ontario homes for sale, neighborhoods, housing styles, and local buyer guidance with Jeff Upp of RE/MAX Champions.",
    "priority": 0.8,
    "changefreq": "weekly"
  },
  {
    "path": "/area/chino-hills",
    "title": "Chino Hills, CA Homes for Sale & Real Estate Guide | Jeff Upp",
    "description": "Explore Chino Hills homes for sale, neighborhoods, housing styles, and local buyer guidance with Jeff Upp of RE/MAX Champions.",
    "priority": 0.8,
    "changefreq": "weekly"
  },
  {
    "path": "/area/chino",
    "title": "Chino, CA Homes for Sale & Real Estate Guide | Jeff Upp",
    "description": "Explore Chino homes for sale, neighborhoods, housing styles, and local buyer guidance with Jeff Upp of RE/MAX Champions.",
    "priority": 0.8,
    "changefreq": "weekly"
  },
  {
    "path": "/area/pomona",
    "title": "Pomona, CA Homes for Sale & Real Estate Guide | Jeff Upp",
    "description": "Explore Pomona homes for sale, neighborhoods, housing styles, and local buyer guidance with Jeff Upp of RE/MAX Champions.",
    "priority": 0.8,
    "changefreq": "weekly"
  },
  {
    "path": "/area/montclair",
    "title": "Montclair, CA Homes for Sale & Real Estate Guide | Jeff Upp",
    "description": "Explore Montclair homes for sale, neighborhoods, housing styles, and local buyer guidance with Jeff Upp of RE/MAX Champions.",
    "priority": 0.8,
    "changefreq": "weekly"
  },
  {
    "path": "/area/fontana",
    "title": "Fontana, CA Homes for Sale & Real Estate Guide | Jeff Upp",
    "description": "Explore Fontana homes for sale, neighborhoods, housing styles, and local buyer guidance with Jeff Upp of RE/MAX Champions.",
    "priority": 0.8,
    "changefreq": "weekly"
  },
  {
    "path": "/area/eastvale",
    "title": "Eastvale, CA Homes for Sale & Real Estate Guide | Jeff Upp",
    "description": "Explore Eastvale homes for sale, neighborhoods, housing styles, and local buyer guidance with Jeff Upp of RE/MAX Champions.",
    "priority": 0.8,
    "changefreq": "weekly"
  },
  {
    "path": "/area/rialto",
    "title": "Rialto, CA Homes for Sale & Real Estate Guide | Jeff Upp",
    "description": "Explore Rialto homes for sale, neighborhoods, housing styles, and local buyer guidance with Jeff Upp of RE/MAX Champions.",
    "priority": 0.8,
    "changefreq": "weekly"
  },
  {
    "path": "/area/corona",
    "title": "Corona, CA Homes for Sale & Real Estate Guide | Jeff Upp",
    "description": "Explore Corona homes for sale, neighborhoods, housing styles, and local buyer guidance with Jeff Upp of RE/MAX Champions.",
    "priority": 0.8,
    "changefreq": "weekly"
  },
  {
    "path": "/guide/first-time-home-buyer-guide-upland",
    "title": "First-Time Home Buyer Guide for Upland, CA | Jeff Upp, RE/MAX Champions",
    "description": "First-Time Home Buyer Guide for Upland, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/selling-a-home-in-upland",
    "title": "How to Sell a Home in Upland, CA | Jeff Upp, RE/MAX Champions",
    "description": "How to Sell a Home in Upland, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/upland-neighborhoods-and-home-styles",
    "title": "Upland Neighborhoods and Home Styles | Jeff Upp, RE/MAX Champions",
    "description": "Upland Neighborhoods and Home Styles: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/upland-condos-vs-single-family-homes",
    "title": "Upland Condos vs. Single-Family Homes | Jeff Upp, RE/MAX Champions",
    "description": "Upland Condos vs. Single-Family Homes: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/moving-to-upland-california",
    "title": "Moving to Upland, California | Jeff Upp, RE/MAX Champions",
    "description": "Moving to Upland, California: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/how-to-price-a-home-in-upland",
    "title": "How to Price a Home in Upland | Jeff Upp, RE/MAX Champions",
    "description": "How to Price a Home in Upland: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/buying-a-home-in-claremont",
    "title": "Buying a Home in Claremont, CA | Jeff Upp, RE/MAX Champions",
    "description": "Buying a Home in Claremont, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/selling-a-home-in-claremont",
    "title": "How to Sell a Home in Claremont, CA | Jeff Upp, RE/MAX Champions",
    "description": "How to Sell a Home in Claremont, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/claremont-village-living-guide",
    "title": "Claremont Village Living Guide | Jeff Upp, RE/MAX Champions",
    "description": "Claremont Village Living Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/historic-homes-in-claremont",
    "title": "Guide to Historic and Character Homes in Claremont | Jeff Upp, RE/MAX Champions",
    "description": "Guide to Historic and Character Homes in Claremont: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/claremont-condo-buying-guide",
    "title": "Claremont Condo Buying Guide | Jeff Upp, RE/MAX Champions",
    "description": "Claremont Condo Buying Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/moving-to-claremont-california",
    "title": "Moving to Claremont, California | Jeff Upp, RE/MAX Champions",
    "description": "Moving to Claremont, California: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/buying-a-home-in-rancho-cucamonga",
    "title": "Buying a Home in Rancho Cucamonga, CA | Jeff Upp, RE/MAX Champions",
    "description": "Buying a Home in Rancho Cucamonga, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/selling-a-home-in-rancho-cucamonga",
    "title": "How to Sell a Home in Rancho Cucamonga | Jeff Upp, RE/MAX Champions",
    "description": "How to Sell a Home in Rancho Cucamonga: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/alta-loma-vs-etiwanda",
    "title": "Alta Loma vs. Etiwanda: Where Should You Buy? | Jeff Upp, RE/MAX Champions",
    "description": "Alta Loma vs. Etiwanda: Where Should You Buy?: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/rancho-cucamonga-condo-guide",
    "title": "Rancho Cucamonga Condo and Townhome Guide | Jeff Upp, RE/MAX Champions",
    "description": "Rancho Cucamonga Condo and Townhome Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/moving-to-rancho-cucamonga",
    "title": "Moving to Rancho Cucamonga, California | Jeff Upp, RE/MAX Champions",
    "description": "Moving to Rancho Cucamonga, California: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/rancho-cucamonga-home-value-guide",
    "title": "Rancho Cucamonga Home Value Guide | Jeff Upp, RE/MAX Champions",
    "description": "Rancho Cucamonga Home Value Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/first-time-home-buyer-guide-ontario",
    "title": "First-Time Home Buyer Guide for Ontario, CA | Jeff Upp, RE/MAX Champions",
    "description": "First-Time Home Buyer Guide for Ontario, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/selling-a-home-in-ontario",
    "title": "How to Sell a Home in Ontario, CA | Jeff Upp, RE/MAX Champions",
    "description": "How to Sell a Home in Ontario, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/ontario-ranch-new-construction-guide",
    "title": "Ontario Ranch New Construction Guide | Jeff Upp, RE/MAX Champions",
    "description": "Ontario Ranch New Construction Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/ontario-condo-buying-guide",
    "title": "Ontario Condo Buying Guide | Jeff Upp, RE/MAX Champions",
    "description": "Ontario Condo Buying Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/moving-to-ontario-california",
    "title": "Moving to Ontario, California | Jeff Upp, RE/MAX Champions",
    "description": "Moving to Ontario, California: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/investment-property-guide-ontario",
    "title": "Ontario Investment Property Guide | Jeff Upp, RE/MAX Champions",
    "description": "Ontario Investment Property Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/buying-a-home-in-chino-hills",
    "title": "Buying a Home in Chino Hills, CA | Jeff Upp, RE/MAX Champions",
    "description": "Buying a Home in Chino Hills, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/selling-a-home-in-chino-hills",
    "title": "How to Sell a Home in Chino Hills | Jeff Upp, RE/MAX Champions",
    "description": "How to Sell a Home in Chino Hills: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/chino-hills-neighborhood-guide",
    "title": "Chino Hills Neighborhood Guide | Jeff Upp, RE/MAX Champions",
    "description": "Chino Hills Neighborhood Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/chino-hills-condo-vs-house",
    "title": "Chino Hills Condo vs. House: Buyer Guide | Jeff Upp, RE/MAX Champions",
    "description": "Chino Hills Condo vs. House: Buyer Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/moving-to-chino-hills",
    "title": "Moving to Chino Hills, California | Jeff Upp, RE/MAX Champions",
    "description": "Moving to Chino Hills, California: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/chino-hills-home-value-guide",
    "title": "Chino Hills Home Value Guide | Jeff Upp, RE/MAX Champions",
    "description": "Chino Hills Home Value Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/first-time-home-buyer-guide-chino",
    "title": "First-Time Home Buyer Guide for Chino, CA | Jeff Upp, RE/MAX Champions",
    "description": "First-Time Home Buyer Guide for Chino, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/selling-a-home-in-chino",
    "title": "How to Sell a Home in Chino, CA | Jeff Upp, RE/MAX Champions",
    "description": "How to Sell a Home in Chino, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/new-construction-homes-in-chino",
    "title": "New Construction Homes in Chino: Buyer Guide | Jeff Upp, RE/MAX Champions",
    "description": "New Construction Homes in Chino: Buyer Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/the-preserve-at-chino-guide",
    "title": "The Preserve at Chino Living Guide | Jeff Upp, RE/MAX Champions",
    "description": "The Preserve at Chino Living Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/moving-to-chino-california",
    "title": "Moving to Chino, California | Jeff Upp, RE/MAX Champions",
    "description": "Moving to Chino, California: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/chino-investment-property-guide",
    "title": "Chino Investment Property Guide | Jeff Upp, RE/MAX Champions",
    "description": "Chino Investment Property Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/buying-a-home-in-pomona",
    "title": "Buying a Home in Pomona, CA | Jeff Upp, RE/MAX Champions",
    "description": "Buying a Home in Pomona, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/selling-a-home-in-pomona",
    "title": "How to Sell a Home in Pomona, CA | Jeff Upp, RE/MAX Champions",
    "description": "How to Sell a Home in Pomona, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/pomona-neighborhood-and-home-style-guide",
    "title": "Pomona Neighborhood and Home Style Guide | Jeff Upp, RE/MAX Champions",
    "description": "Pomona Neighborhood and Home Style Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/pomona-condo-vs-house",
    "title": "Pomona Condo vs. House: Buyer Guide | Jeff Upp, RE/MAX Champions",
    "description": "Pomona Condo vs. House: Buyer Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/moving-to-pomona-california",
    "title": "Moving to Pomona, California | Jeff Upp, RE/MAX Champions",
    "description": "Moving to Pomona, California: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/pomona-home-value-guide",
    "title": "Pomona Home Value Guide | Jeff Upp, RE/MAX Champions",
    "description": "Pomona Home Value Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/first-time-home-buyer-guide-montclair",
    "title": "First-Time Home Buyer Guide for Montclair, CA | Jeff Upp, RE/MAX Champions",
    "description": "First-Time Home Buyer Guide for Montclair, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/selling-a-home-in-montclair",
    "title": "How to Sell a Home in Montclair, CA | Jeff Upp, RE/MAX Champions",
    "description": "How to Sell a Home in Montclair, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/montclair-condo-townhome-guide",
    "title": "Montclair Condo and Townhome Guide | Jeff Upp, RE/MAX Champions",
    "description": "Montclair Condo and Townhome Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/montclair-neighborhood-guide",
    "title": "Montclair Neighborhood Guide for Home Buyers | Jeff Upp, RE/MAX Champions",
    "description": "Montclair Neighborhood Guide for Home Buyers: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/moving-to-montclair-california",
    "title": "Moving to Montclair, California | Jeff Upp, RE/MAX Champions",
    "description": "Moving to Montclair, California: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/montclair-home-value-guide",
    "title": "Montclair Home Value Guide | Jeff Upp, RE/MAX Champions",
    "description": "Montclair Home Value Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/first-time-home-buyer-guide-fontana",
    "title": "First-Time Home Buyer Guide for Fontana, CA | Jeff Upp, RE/MAX Champions",
    "description": "First-Time Home Buyer Guide for Fontana, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/selling-a-home-in-fontana",
    "title": "How to Sell a Home in Fontana, CA | Jeff Upp, RE/MAX Champions",
    "description": "How to Sell a Home in Fontana, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/north-fontana-neighborhood-guide",
    "title": "North Fontana Neighborhood Guide | Jeff Upp, RE/MAX Champions",
    "description": "North Fontana Neighborhood Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/fontana-new-construction-guide",
    "title": "Fontana New Construction Home Guide | Jeff Upp, RE/MAX Champions",
    "description": "Fontana New Construction Home Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/moving-to-fontana-california",
    "title": "Moving to Fontana, California | Jeff Upp, RE/MAX Champions",
    "description": "Moving to Fontana, California: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/fontana-home-value-guide",
    "title": "Fontana Home Value Guide | Jeff Upp, RE/MAX Champions",
    "description": "Fontana Home Value Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/buying-a-home-in-eastvale",
    "title": "Buying a Home in Eastvale, CA | Jeff Upp, RE/MAX Champions",
    "description": "Buying a Home in Eastvale, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/selling-a-home-in-eastvale",
    "title": "How to Sell a Home in Eastvale, CA | Jeff Upp, RE/MAX Champions",
    "description": "How to Sell a Home in Eastvale, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/eastvale-new-construction-guide",
    "title": "Eastvale New Construction Home Guide | Jeff Upp, RE/MAX Champions",
    "description": "Eastvale New Construction Home Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/eastvale-neighborhood-guide",
    "title": "Eastvale Neighborhood Guide for Home Buyers | Jeff Upp, RE/MAX Champions",
    "description": "Eastvale Neighborhood Guide for Home Buyers: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/moving-to-eastvale-california",
    "title": "Moving to Eastvale, California | Jeff Upp, RE/MAX Champions",
    "description": "Moving to Eastvale, California: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/eastvale-home-value-guide",
    "title": "Eastvale Home Value Guide | Jeff Upp, RE/MAX Champions",
    "description": "Eastvale Home Value Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/first-time-home-buyer-guide-rialto",
    "title": "First-Time Home Buyer Guide for Rialto, CA | Jeff Upp, RE/MAX Champions",
    "description": "First-Time Home Buyer Guide for Rialto, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/selling-a-home-in-rialto",
    "title": "How to Sell a Home in Rialto, CA | Jeff Upp, RE/MAX Champions",
    "description": "How to Sell a Home in Rialto, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/north-rialto-neighborhood-guide",
    "title": "North Rialto Neighborhood Guide | Jeff Upp, RE/MAX Champions",
    "description": "North Rialto Neighborhood Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/rialto-new-construction-guide",
    "title": "Rialto New Construction Home Guide | Jeff Upp, RE/MAX Champions",
    "description": "Rialto New Construction Home Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/moving-to-rialto-california",
    "title": "Moving to Rialto, California | Jeff Upp, RE/MAX Champions",
    "description": "Moving to Rialto, California: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/rialto-home-value-guide",
    "title": "Rialto Home Value Guide | Jeff Upp, RE/MAX Champions",
    "description": "Rialto Home Value Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/buying-a-home-in-corona",
    "title": "Buying a Home in Corona, CA | Jeff Upp, RE/MAX Champions",
    "description": "Buying a Home in Corona, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/selling-a-home-in-corona",
    "title": "How to Sell a Home in Corona, CA | Jeff Upp, RE/MAX Champions",
    "description": "How to Sell a Home in Corona, CA: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/corona-commuter-home-buying-guide",
    "title": "Corona Commuter Home Buying Guide | Jeff Upp, RE/MAX Champions",
    "description": "Corona Commuter Home Buying Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/corona-condo-vs-house",
    "title": "Corona Condo vs. House: Buyer Guide | Jeff Upp, RE/MAX Champions",
    "description": "Corona Condo vs. House: Buyer Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/moving-to-corona-california",
    "title": "Moving to Corona, California | Jeff Upp, RE/MAX Champions",
    "description": "Moving to Corona, California: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/corona-home-value-guide",
    "title": "Corona Home Value Guide | Jeff Upp, RE/MAX Champions",
    "description": "Corona Home Value Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/inland-empire-home-buying-guide",
    "title": "Inland Empire Home Buying Guide | Jeff Upp, RE/MAX Champions",
    "description": "Inland Empire Home Buying Guide: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  },
  {
    "path": "/guide/sell-a-home-in-the-inland-empire",
    "title": "How to Sell a Home in the Inland Empire | Jeff Upp, RE/MAX Champions",
    "description": "How to Sell a Home in the Inland Empire: practical local guidance from Jeff Upp, a Southern California REALTOR® serving clients since 1990.",
    "priority": 0.7,
    "changefreq": "monthly"
  }
];
